import { apiClient } from './client'

export type NotificationType =
  | 'trophy_unlocked'
  | 'tree_unlocked'
  | 'ai_rating_complete'
  | 'friend_request'
  | 'friend_accepted'

export type AppNotification = {
  id: number
  type: NotificationType
  title: string
  body: string
  target_url: string
  is_read: boolean
  created_at: string
}

export type NotificationListResponse = {
  results: AppNotification[]
  unread_count: number
}

export const getNotifications = () =>
  apiClient.get<NotificationListResponse>('/notifications/').then((r) => r.data)

export const markRead = (id: number) =>
  apiClient.patch<AppNotification>(`/notifications/${id}/read/`).then((r) => r.data)

export const markAllRead = () =>
  apiClient.post('/notifications/read-all/')
